import * as React from 'react';

import { EParkingType, getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { Parking } from '../../../components/advancedFilters/Parking';
import { useContext } from '../../../utils/useContext';
import { useOfferType } from '../../../utils/useOfferType';

export const ParkingContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const offerType = useOfferType();
  let parkingType = getTermsValue('parking_type')(jsonQuery);
  if (parkingType && parkingType.length === 0) {
    parkingType = null;
  }

  const handleChange = React.useCallback(
    (parkingType: EParkingType[] | null) => {
      onChange({ action: 'setParkingType', arguments: [parkingType] });
    },
    [onChange],
  );

  return (
    <Parking offerType={offerType} value={parkingType as NonEmptyArray<EParkingType> | null} onChange={handleChange} />
  );
};
